// src/hooks/useVocabChallenge.js
import { useState, useEffect, useRef, useCallback } from 'react';

const SECONDS_PER_WORD = 10;

const buildOptions = (words, currentIdx) => {
  const correct = words[currentIdx];
  const distractors = words
    .filter((_, i) => i !== currentIdx)
    .sort(() => Math.random() - 0.5)
    .slice(0, 3);
  return [...distractors, correct].sort(() => Math.random() - 0.5);
};

export const useVocabChallenge = (words = [], onFinish) => {
  const [cardIdx,      setCardIdx]      = useState(0);
  const [timeLeft,     setTimeLeft]     = useState(SECONDS_PER_WORD);
  const [score,        setScore]        = useState(0);
  const [results,      setResults]      = useState([]);
  const [phase,        setPhase]        = useState('playing');
  const [options,      setOptions]      = useState(() => buildOptions(words, 0));
  const [lastCorrect,  setLastCorrect]  = useState(null);
  const timerRef = useRef(null);

  const currentWord = words[cardIdx];

  // ✅ advance ahora recibe el string elegido por el usuario
  const advance = useCallback((isCorrect, selected = null) => {
    clearInterval(timerRef.current);
    setLastCorrect(isCorrect);
    setPhase('feedback');

    if (isCorrect) setScore(s => s + 1);

    // ✅ Guarda word, correct y selected
    setResults(prev => [...prev, {
      word:     words[cardIdx],
      correct:  isCorrect,
      selected: selected,        // ← null si fue por timeout
    }]);

    setTimeout(() => {
      const next = cardIdx + 1;
      if (next >= words.length) {
        setPhase('finished');
        onFinish?.();
      } else {
        setCardIdx(next);
        setOptions(buildOptions(words, next));
        setTimeLeft(SECONDS_PER_WORD);
        setLastCorrect(null);
        setPhase('playing');
      }
    }, 800);
  }, [cardIdx, words, onFinish]);

  const reset = useCallback(() => {
  clearInterval(timerRef.current);
  setCardIdx(0);
  setTimeLeft(SECONDS_PER_WORD);
  setScore(0);
  setResults([]);
  setPhase('playing');
  setOptions(buildOptions(words, 0));
  setLastCorrect(null);
}, [words]);

  // Timer — timeout pasa null como selected (sin respuesta)
  useEffect(() => {
    if (phase !== 'playing') return;
    timerRef.current = setInterval(() => {
      setTimeLeft(t => {
        if (t <= 1) {
          advance(false, null);   // ← null = tiempo agotado
          return SECONDS_PER_WORD;
        }
        return t - 1;
      });
    }, 1000);
    return () => clearInterval(timerRef.current);
  }, [phase, advance]);

  return {
    currentWord,
    options,
    timeLeft,
    score,
    results,
    phase,
    lastCorrect,
    cardIdx,
    totalWords: words.length,
    SECONDS_PER_WORD,
    reset,
    onAnswer: (selectedEs) => advance(selectedEs === currentWord?.es, selectedEs),
  };
};
